
export const TYPE_FIELD_LIST = [
  {
    value: 'random_id',
    title: 'Id Aleatorio'
  },
  {
    value: 'text',
    title: 'Texto'
  },
  {
    value: 'number',
    title: 'Número'
  },
  {
    value: 'textarea',
    title: 'Área de texto'
  },
  {
    value: 'radio',
    title: 'Radio'
  },
  {
    value: 'checkbox',
    title: 'Checkbox'
  },
  {
    value: 'select',
    title: 'Lista desplegable'
  },
  {
    value: 'multi_select',
    title: 'Lista multi-opción'
  },
  {
    value: 'date',
    title: 'Fecha'
  },
  {
    value: 'date_range',
    title: 'Rango de fechas'
  },
  {
    value: 'datetime',
    title: 'Fecha y hora'
  },
  {
    value: 'datetime_range',
    title: 'Rango de fecha y hora'
  },
  {
    value: 'hour',
    title: 'Hora'
  },
  {
    value: 'hours',
    title: 'Horas (cantidad)'
  },
  {
    value: 'location',
    title: 'Ubicacion'
  },
  {
    value: 'picture',
    title: 'Imagen'
  },
  {
    value: 'picture_compress',
    title: 'Imagen Comprimida'
  },
  {
    value: 'region_list',
    title: 'Regiones'
  },
  {
    value: 'field_list',
    title: 'Parcelas'
  },
  {
    value: 'product_list',
    title: 'Productos'
  },
  {
    value: 'machinery_list',
    title: 'Maquinaria'
  },
  {
    value: 'user_list',
    title: 'Usuarios'
  },
  { value:'customentity_list',
    title:'Entidad personalizada'
  },
  { value:'subform',
    title:'Subformulario'
  },
  { value:'sequence',
    title:'Secuencia'
  }
];

export const EDITABLE_FIELDS = ['auto','elements','id'];

export const FIELD_TYPE_VALUES = {

  'random_id':'Id Aleatorio',
  'text':'Texto'
  ,
  'number': 'Número'
  ,
  'textarea':'Área de texto',
  'radio': 'Radio',
  'checkbox': 'Checkbox',
  'select': 'Lista desplegable',
  'multi_select': 'Lista multi-opción',
  'date': 'Fecha',
  'date_range': 'Rango de fechas',
  'datetime': 'Fecha y hora',
  'datetime_range': 'Rango de fecha y hora'
  ,
  'hour': 'Hora',
  'hours': 'Horas (cantidad)',
  'location': 'Ubicacion',
  'picture': 'Imagen',
  'picture_compress': 'Imagen Comprimida',
  'region_list': 'Regiones',
  'field_list': 'Parcelas',
  'product_list': 'Productos',
  'machinery_list': 'Maquinaria',
  'user_list': 'Usuarios',
  'customentity_list': 'Entidad Personalizada',
  'subform': 'Subformulario',
  'sequence': 'Secuencia'
}
